import Races from './Races';
import Tracks from './Tracks';
import Starts from './Starts';

export default {
	race: Races,
	track: Tracks,
	field_start: Starts
};



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/store/Collections.js
 **/